import MUIToggleButton from "@mui/material/ToggleButton";
import {styled} from "@mui/material/styles";

export const ToggleButton = styled(MUIToggleButton)({
    borderRadius: '10px !important',
    fontSize: '14px !important',
    lineHeight: '14px !important',
    padding: '8px 10px !important',
    textTransform: 'capitalize',
});
